import { cn } from '../../../../helpers';
import { useClassHelper } from '../../../../hooks';
import { Stack } from '../../../Stack';

const componentName = 'w-PlanInfo';

// Shared by every text row: reset the browser heading/paragraph margins and
// inherit the carrier theme font/color tokens.
const rowClassName =
  'm-0 [font-family:var(--font-stack)] text-[color:var(--color-font-primary)]';

interface Props {
  name?: string;
  description?: string;
  descriptionExtended?: string;
  // Carrier flag (watch_transfer_disable_plan_description): the extended
  // copy is configured but must not be shown on this screen.
  hideDescriptionExtended?: boolean;
  className?: string;
}

/**
 * Read-only plan summary card shared by the Watch templates (transfer,
 * manage). Renders the resolved plan detail copy — callers own locale
 * resolution (`findPlanDetails`) and pass plain strings.
 */
export const PlanInfo = ({
  name,
  description,
  descriptionExtended,
  hideDescriptionExtended = false,
  className,
}: Props) => {
  const c = useClassHelper(componentName);

  return (
    <Stack
      direction="column"
      gap={3}
      className={cn(
        c('base'),
        'mb-6 bg-[var(--background-darker)] p-4',
        className,
      )}
    >
      <Stack direction="column" gap={2}>
        <h2 className={cn(rowClassName, 'text-[20px] font-bold leading-none')}>
          {name}
        </h2>
        <p className={cn(rowClassName, 'opacity-80 leading-none')}>
          {description}
        </p>
      </Stack>
      {!hideDescriptionExtended && descriptionExtended && (
        <p className={cn(rowClassName, 'leading-none')}>
          {descriptionExtended}
        </p>
      )}
    </Stack>
  );
};
